import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var InboxMessageTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(InboxMessageTransformer, _BaseTransformer);
  var _super = _createSuper(InboxMessageTransformer);
  function InboxMessageTransformer() {
    _classCallCheck(this, InboxMessageTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(InboxMessageTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {};
    }
  }, {
    key: "send",
    value: function send(data) {
      return {
        thread: data.thread,
        message: data.message,
        stripped_message: data.strippedMessage,
        sender: data.sender,
        bcc: data.bcc,
        cc: data.cc,
        send_date: data.sendDate,
        draft: data.draft,
        solution: data.solution,
        sender_contact: data.senderContact && data.senderContact.id,
        sender_name: data.senderName,
        sender_email: data.senderEmail,
        sender_phone: data.senderPhone,
        record_id: data.recordId
      };
    }
  }]);
  return InboxMessageTransformer;
}(BaseTransformer);